(function () {
  var root = document.querySelector('[data-bbc-root]'); if (!root) return;
  var f = root.querySelector('[data-bbc]');
  var UPV = root.dataset.uploadVariant, PV = root.dataset.paintedVariant, PP = +root.dataset.paintedPrice || 100;
  var RATE = 7, FLOOR = 150, MAX = 6, LONG = 2400;
  var DET = { loose: [0.4, 'Loose', 'Gestural marks. Character over precision. Visible paper texture.'],
              tonal: [0.65, 'Tonal', 'Atmospheric modelling. Soft gradients. Form without finish.'],
              detailed: [1, 'Detailed', 'Full tonal range. Textural specificity. Hair and eyes defined.'],
              hyper: [1.8, 'Hyperrealistic', 'Individual hairs. Reflective eyes. Every mark is accounted for.'] };
  var SUR = { cold: [1, 'Cold press', '140 lb paper with tooth. The most room for fine detail.'],
              wood: [0.85, 'Wood panel', 'Smooth hardwood surface. Richer blacks, less texture.'] };
  var $ = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
  var el = function (k) { return root.querySelector('[data-el="' + k + '"]'); };
  var set = function (n, a) { for (var k in a) n.setAttribute(k, a[k]); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };
  var S = 13, OX = 48, OY = 28; // px per inch in the drawing, origin
  var P = { list: [], fx: 0.5, fy: 0.5, z: 1, box: null };
  function line(k, x1, y1, x2, y2) { set(el(k), { x1: x1, y1: y1, x2: x2, y2: y2 }); }
  function price(w, h, d, s) { return Math.max(FLOOR, Math.round(w * h * RATE * DET[d][0] * SUR[s][0] / 25) * 25); }
  function painted() { return f.medium.value === 'painted'; }
  function dims() { return painted() ? [5, 7] : [+f.w.value, +f.h.value]; }
  function say(k, msg, err) { var n = el(k); if (n) { n.textContent = msg || ''; n.classList.toggle('is-error', !!err); } }

  function update() {
    var wh = dims(), w = wh[0], h = wh[1], d = f.detail.value, s = f.surface.value, pt = painted();
    root.dataset.medium = pt ? 'painted' : 'graphite';
    $('w').textContent = w + ' in'; $('h').textContent = h + ' in';
    $('detail-desc').textContent = DET[d][2]; $('surface-desc').textContent = SUR[s][2];
    var cw = w * S, ch = h * S;
    // Zoom the drawing to fit the larger of canvas and letter sheet; square so the page doesn't jump.
    P.V = Math.max(OX + Math.max(cw, 8.5 * S) + 24, OY + Math.max(ch, 11 * S) + 44); $('svg').setAttribute('viewBox', '0 0 ' + P.V + ' ' + P.V);
    set(el('canvas'), { x: OX, y: OY, width: cw, height: ch });
    set(el('letter'), { x: OX, y: OY, width: 8.5 * S, height: 11 * S });
    set(el('letter-t'), { x: OX, y: OY - 8 });
    var by = OY + ch + 18; line('dimw-l', OX, by, OX + cw, by); line('dimw-a', OX, by - 6, OX, by + 6); line('dimw-b', OX + cw, by - 6, OX + cw, by + 6);
    set(el('dimw-t'), { x: OX + cw / 2, y: by + 16 }); el('dimw-t').textContent = w + ' IN';
    var lx = OX - 18; line('dimh-l', lx, OY, lx, OY + ch); line('dimh-a', lx - 6, OY, lx + 6, OY); line('dimh-b', lx - 6, OY + ch, lx + 6, OY + ch);
    set(el('dimh-t'), { x: lx - 10, y: OY + ch / 2, transform: 'rotate(-90 ' + (lx - 10) + ' ' + (OY + ch / 2) + ')' }); el('dimh-t').textContent = h + ' IN';
    var p, spec;
    if (pt) {
      p = PP; spec = 'Painted portrait 5x7';
      $('area-l').textContent = 'Painted portrait, 5 × 7 in, acrylic on cold press'; $('area-v').textContent = money(p);
      $('price-l').textContent = 'Price';
    } else {
      p = price(w, h, d, s); spec = w + 'x' + h + ' ' + DET[d][1] + ' ' + SUR[s][1];
      $('area-l').textContent = w + ' × ' + h + ' in = ' + (w * h) + ' sq in × $' + RATE; $('area-v').textContent = money(w * h * RATE);
      $('det-l').textContent = 'Detail: ' + DET[d][1]; $('det-v').textContent = '× ' + DET[d][0];
      $('sur-l').textContent = 'Surface: ' + SUR[s][1]; $('sur-v').textContent = '× ' + SUR[s][0];
      $('price-l').textContent = 'Estimated price';
    }
    $('price').textContent = money(p); $('order-p').textContent = money(p);
    el('order').hidden = !PV;
    var tags = document.querySelector('#bb-waitlist input[name="contact[tags]"]');
    if (tags && !pt) tags.value = 'newsletter,commission-waitlist,spec ' + spec;
    var spv = { medium: pt ? 'Painted portrait (acrylic)' : 'Graphite drawing', size: w + ' × ' + h + ' in',
                surface: pt ? 'Cold press' : SUR[s][1], detail: pt ? '' : DET[d][1], estimate: money(p) };
    root.querySelectorAll('[data-spec]').forEach(function (n) { n.value = spv[n.dataset.spec]; });
    var sum = $('summary');
    if (sum) sum.textContent = 'Your spec: ' + [spv.medium, spv.size, spv.surface, spv.detail].filter(Boolean).join(', ') + ' · ' + (pt ? '' : 'estimate ') + spv.estimate +
      ' · ' + (P.list.length ? P.list.length + ' photo' + (P.list.length > 1 ? 's' : '') + (P.list[0].w ? ' and your mock-up' : '') : 'no photos yet') + '.';
    frame();
  }

  // Photo framing: P.fx/P.fy is the image point (0-1) shown at the centre of the canvas.
  function frame() {
    var ph = el('photo'), m = P.list[0], c = el('canvas');
    el('frame-tools').hidden = !(m && m.w);
    $('cap').textContent = m && m.w ? 'Drawn to scale. Drag the photo to frame it.' : 'Drawn to scale. The dashed outline is a sheet of letter paper.';
    if (!m || !m.w) { ph.setAttribute('display', 'none'); c.setAttribute('fill', 'rgba(245,240,235,.1)'); P.box = null; return; }
    var r = { x: +c.getAttribute('x'), y: +c.getAttribute('y'), w: +c.getAttribute('width'), h: +c.getAttribute('height') };
    var W = m.w * Math.max(r.w / m.w, r.h / m.h) * P.z, H = W * m.h / m.w;
    var x = Math.min(r.x, Math.max(r.x + r.w - W, r.x + r.w / 2 - P.fx * W));
    var y = Math.min(r.y, Math.max(r.y + r.h - H, r.y + r.h / 2 - P.fy * H));
    P.fx = (r.x + r.w / 2 - x) / W; P.fy = (r.y + r.h / 2 - y) / H;
    set(el('clip-r'), { x: r.x, y: r.y, width: r.w, height: r.h });
    set(ph, { display: 'inline', href: m.url, x: x, y: y, width: W, height: H, filter: !painted() && f.mono.checked ? 'url(#bbc-gray)' : 'none' });
    c.setAttribute('fill', 'none');
    P.box = { x: x, y: y, W: W, r: r };
  }

  // The mock-up as a JPEG at 100 px per inch, cropped exactly as framed.
  function mockup() {
    var m = P.list[0], b = P.box; if (!m || !m.w || !b) return Promise.resolve(null);
    var k = m.w / b.W, out = 100 / S, cv = document.createElement('canvas');
    cv.width = Math.round(b.r.w * out); cv.height = Math.round(b.r.h * out);
    var g = cv.getContext('2d');
    g.drawImage(m.img, (b.r.x - b.x) * k, (b.r.y - b.y) * k, b.r.w * k, b.r.h * k, 0, 0, cv.width, cv.height);
    if (!painted() && f.mono.checked) {
      var d = g.getImageData(0, 0, cv.width, cv.height), a = d.data;
      for (var i = 0; i < a.length; i += 4) { var v = (0.3 * a[i] + 0.59 * a[i + 1] + 0.11 * a[i + 2] - 128) * 1.15 + 128; a[i] = a[i + 1] = a[i + 2] = v; }
      g.putImageData(d, 0, 0);
    }
    return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', 0.9); });
  }

  function thumbs() {
    var ul = el('thumbs'); ul.textContent = '';
    P.list.forEach(function (it, i) {
      var li = document.createElement('li'); li.className = 'bbc__thumb';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bbc__thumb-pick';
      b.setAttribute('aria-pressed', i === 0); b.setAttribute('aria-label', (i ? 'Make main reference: ' : 'Main reference: ') + it.name);
      if (it.url) { var im = document.createElement('img'); im.src = it.url; im.alt = ''; b.appendChild(im); } else b.textContent = it.name;
      b.onclick = function () { if (i) { P.list.unshift(P.list.splice(i, 1)[0]); P.fx = P.fy = 0.5; P.z = 1; f.z.value = 100; render(); } };
      var x = document.createElement('button'); x.type = 'button'; x.className = 'bbc__thumb-x'; x.textContent = '×'; x.setAttribute('aria-label', 'Remove ' + it.name);
      x.onclick = function () { P.list.splice(i, 1); if (!i) { P.fx = P.fy = 0.5; P.z = 1; f.z.value = 100; } render(); };
      var t = document.createElement('span'); t.className = 'bbc__thumb-t'; t.textContent = i ? 'Ref ' + i : 'Main';
      li.appendChild(b); li.appendChild(x); li.appendChild(t); ul.appendChild(li);
    });
  }
  function render() { thumbs(); update(); }

  function addFiles(files) {
    var room = MAX - P.list.length, list = [].slice.call(files).filter(function (fl) { return /^image\//.test(fl.type) || /\.(heic|heif)$/i.test(fl.name); });
    if (list.length > room) say('pstatus', 'Up to ' + MAX + ' photos. The extras were left out.');
    else say('pstatus', '');
    list.slice(0, room).forEach(function (file) {
      var it = { name: file.name, blob: file }; P.list.push(it);
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () {
        // Shrink big phone photos before upload; keeps the request fast on mobile data.
        var r = Math.min(1, LONG / Math.max(im.naturalWidth, im.naturalHeight)), cv = document.createElement('canvas');
        cv.width = Math.round(im.naturalWidth * r); cv.height = Math.round(im.naturalHeight * r);
        cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height); URL.revokeObjectURL(u);
        cv.toBlob(function (bl) {
          it.img = cv; it.w = cv.width; it.h = cv.height;
          if (bl) { it.blob = bl; it.name = file.name.replace(/\.[^.]+$/, '') + '.jpg'; it.url = URL.createObjectURL(bl); }
          render();
        }, 'image/jpeg', 0.9);
      };
      im.onerror = function () { URL.revokeObjectURL(u); say('pstatus', file.name + " can't be previewed here, but it will still be sent."); render(); };
      im.src = u;
    });
    render();
  }

  // Files go up through Shopify's own line-item file upload on a hidden product; the links come back in the response.
  function upload(variant, keep) {
    return mockup().then(function (mk) {
      var fd = new FormData(); fd.append('id', variant); fd.append('quantity', '1');
      if (mk) fd.append('properties[Mock-up]', new File([mk], 'mockup.jpg', { type: 'image/jpeg' }));
      P.list.forEach(function (it, i) { fd.append('properties[' + (i ? 'Reference ' + i : 'Main photo') + ']', new File([it.blob], it.name, { type: it.blob.type || 'application/octet-stream' })); });
      return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    }).then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
      .then(function (ln) {
        if (keep) return ln.properties;
        // Remove only this line, so anything else in the visitor's cart stays.
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: ln.key, quantity: 0 }) })
          .then(function () { return ln.properties; });
      });
  }

  var rq = document.getElementById('bb-request-form'), ready = false, skip = false;
  if (rq) rq.addEventListener('submit', function (e) {
    if (ready || skip || !P.list.length || !UPV) return;
    e.preventDefault();
    var btn = rq.querySelector('[type="submit"]'); btn.disabled = true; say('rstatus', 'Uploading your photos…');
    upload(UPV, false).then(function (props) {
      for (var k in props) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'contact[' + k + ']'; h.value = props[k]; rq.appendChild(h); }
      ready = true; btn.disabled = false; say('rstatus', 'Sending…');
      rq.requestSubmit ? rq.requestSubmit() : rq.submit();
    }).catch(function () {
      skip = true; btn.disabled = false;
      say('rstatus', "Your photos didn't upload. Press Send request again to send it without them, then reply to Brooks's email with your photos.", true);
    });
  });

  el('order').addEventListener('click', function () {
    if (!PV) return;
    if (!P.list.length) { say('pstatus', 'Add a photo of your pet first.', true); el('files').focus(); return; }
    var b = el('order'); b.disabled = true; say('pstatus', 'Uploading your photos…');
    upload(PV, true).then(function () { location.href = '/cart'; })
      .catch(function () { b.disabled = false; say('pstatus', "Your photos didn't upload. Check your connection and try again.", true); });
  });

  var ph = el('photo'), drag = null;
  ph.addEventListener('pointerdown', function (e) { if (!P.box) return; drag = { x: e.clientX, y: e.clientY }; ph.setPointerCapture(e.pointerId); ph.style.cursor = 'grabbing'; });
  ph.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var k = P.V / el('photo').ownerSVGElement.getBoundingClientRect().width;
    P.fx -= (e.clientX - drag.x) * k / P.box.W; P.fy -= (e.clientY - drag.y) * k / (P.box.W * P.list[0].h / P.list[0].w);
    drag = { x: e.clientX, y: e.clientY }; frame();
  });
  ph.addEventListener('pointerup', function () { drag = null; ph.style.cursor = ''; });
  ph.addEventListener('keydown', function (e) {
    var d = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
    if (!d) return; e.preventDefault(); P.fx += d[0] * 0.02; P.fy += d[1] * 0.02; frame();
  });

  var drop = el('drop');
  el('files').addEventListener('change', function () { addFiles(this.files); this.value = ''; });
  ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { e.preventDefault(); addFiles(e.dataTransfer.files); });

  f.addEventListener('input', function (e) { if (e.target.name === 'z') { P.z = e.target.value / 100; $('z').textContent = e.target.value + '%'; } update(); });
  f.addEventListener('change', update);
  console.assert(price(8, 10, 'detailed', 'cold') === 550 && price(4, 4, 'loose', 'wood') === 150, 'bbc price check');
  update();
})();